var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "130px",
    viewBox: "0 0 120 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "welcome  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00184900986%",
    y1: "50.0122402%",
    x2: "100.011094%",
    y2: "50.0122402%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCFFC",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.011139772%",
    y1: "49.9857943%",
    x2: "100.01428%",
    y2: "49.9857943%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCFFC",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0099844765%",
    y1: "50.0084814%",
    x2: "99.9969772%",
    y2: "50.0084814%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCFFC",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F5FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0516\\u66F4\\u65B0--\\u6FC0\\u6D3B\\u58F0\\u97F3\\u5F39\\u7A97",
    transform: "translate(-660.000000, -277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F-2(1)",
    transform: "translate(660.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    opacity: 0.86,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0878628,0.0143663767 C73.3109776,0.0143663767 86.532908,0.0143663767 99.7536539,0.0143663767 C105.840503,0.0143663767 108.281639,2.47819998 108.281639,8.55876893 C108.281639,23.4040249 108.281639,38.2420976 108.281639,53.0729872 C108.281639,59.4696164 106.000403,61.7718283 99.6008608,61.7933778 C91.2007954,61.8221106 82.7971767,61.7682367 74.393558,61.7933778 C68.5128015,61.8149274 66.0503458,64.4834819 66.4412118,70.3162308 C66.6117715,72.8914038 66.7965445,75.4629853 66.9919775,78.0381583 C67.0523841,78.8606334 67.4290368,79.8124058 66.1747123,80.1320577 C64.9203878,80.4517096 64.5792684,79.6292345 64.0889092,78.6738705 C62.131026,74.8344563 59.9208565,71.1315227 58.0482531,67.2454178 C56.4030626,63.8477697 53.9619268,62.2674683 50.1563134,62.3069758 C40.5196902,62.411132 30.8795136,62.3572581 21.239337,62.3357086 C14.5839553,62.3357086 12.2174394,60.0119471 12.2103327,53.4932037 C12.1890128,38.5306223 12.1890128,23.5656466 12.2103327,8.59827646 C12.2103327,3.15341969 15.3550273,0.00718318836 20.7916178,0 C33.8891817,0 46.9879301,0.00478879224 60.0878628,0.0143663767 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.052133,115.448203 C97.2094717,115.448203 94.34549,115.721164 91.5454682,115.394329 C84.8687664,114.611362 80.7895469,109.238337 81.1306663,102.522056 C81.3651859,97.8960825 82.3920974,93.9022298 86.0378111,90.5943715 C89.3566186,87.5882072 96.4845929,86.7298162 99.7998472,89.7539385 C102.997842,92.6631298 106.217156,95.6944353 105.414104,100.7514 C105.279078,101.613382 104.948618,103.042837 106.419696,103.057203 C107.954733,103.057203 107.841027,101.566692 107.901433,100.517946 C108.533925,90.9714889 100.364826,84.4707035 91.5561281,85.63438 C85.0535395,86.4963626 81.2266061,90.5009901 79.8301485,97.3286106 C79.2189763,100.341958 78.053485,103.272699 78.7641504,106.436893 C80.2991877,113.289655 85.6753717,117.700133 92.7962393,117.85098 C96.7475391,117.933586 100.702392,117.85098 104.657245,117.937178 C108.054226,118.005418 110.651708,120.483618 110.754755,123.608305 C110.864908,126.873064 108.601439,129.624225 105.101411,129.714015 C99.309488,129.872045 93.4607115,130.453884 87.7220881,129.293799 C72.9189272,126.305592 64.1279958,112.197811 67.290457,98.0469295 C68.8610276,91.0217712 71.0036839,84.4742951 76.848907,79.7621235 C78.0037384,78.8319006 78.0463783,77.4347705 78.3235378,76.0915143 C79.3362361,71.1853966 81.9159516,68.6820555 86.9439095,68.5491665 C93.6490378,68.3516288 100.645539,67.1699943 106.423249,72.1838598 C106.888735,72.5897099 107.528334,72.9021786 107.8126,73.394227 C111.969993,80.7103044 118.024862,86.9955942 119.638073,95.7088017 C120.462445,100.158787 119.826399,104.439967 118.259382,108.444595 C116.365458,113.289655 112.048166,115.268624 107.084168,115.692432 C104.753185,115.893561 102.390223,115.728348 100.045027,115.728348 L100.052133,115.448203 Z M94.6723961,100.675976 C94.4911764,99.8283602 94.9637689,98.2516503 93.4678182,98.6179929 C91.9718674,98.9843355 92.3058802,100.808865 92.0464873,102.051557 C91.8759276,102.899173 92.0464873,104.120315 93.1124854,103.937144 C94.8678291,103.642633 94.4911764,101.943809 94.6723961,100.672385 L94.6723961,100.675976 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96766011,103.714465 C9.94867013,103.739132 11.7995263,102.719666 12.8528627,101.023656 C13.9061991,99.3276473 14.010096,97.1997061 13.1270911,95.4071077 C12.3418058,93.7908904 10.8316418,94.1823741 9.54533737,94.2146985 C7.23922805,94.2685724 5.10723175,94.0099776 3.53310782,92.059742 C2.29880016,90.5493117 1.90333141,88.5106744 2.48193325,86.6409481 C3.06053509,84.7712217 4.53481657,83.3237232 6.40064284,82.793429 C7.35973471,82.5572381 8.34522147,82.4485726 9.33213774,82.4701855 C14.8149215,82.315747 14.8149215,82.3301133 15.514927,76.9678632 C16.1047793,72.438863 18.414442,70.1007352 21.9961957,70.4167955 C25.5175429,70.7256725 27.397253,73.4085934 27.20182,77.9591432 C27.1058802,80.2362139 26.6617143,82.4522275 30.2185948,82.5204678 C35.7511252,82.6282157 36.237931,82.4630023 36.6572236,78.3865429 C36.7425034,77.5245603 36.7567167,76.6518029 36.8952965,75.8005951 C37.4602755,72.3095656 40.0222244,70.1617923 43.2664121,70.4132039 C46.3755734,70.6646154 48.706556,73.4481009 48.6425961,76.8349742 C48.5431029,82.0715186 48.5431029,82.0715186 53.9370535,82.4630023 C57.7817535,82.7431467 60.2299959,85.0920493 60.1518227,88.4322318 C60.0736495,91.7724144 57.5934272,94.024344 53.7558339,94.1787825 C53.1375549,94.2003321 52.519276,94.1787825 51.9009971,94.1787825 C47.1040054,94.2003321 45.0004357,96.8940277 46.0202406,101.660073 C46.2583136,102.762693 46.8801458,103.45587 47.9674639,103.588759 C48.9484259,103.688802 49.9346689,103.72599 50.9202788,103.700099 C55.1060982,103.700099 57.7746469,105.7078 58.0269331,109.08749 C58.286326,112.653943 55.6995038,115.1932 51.4461712,115.552359 C51.0908385,115.584684 50.7070792,115.595459 50.3375331,115.602642 C44.9222625,115.670882 44.9222625,115.66729 43.9415442,120.799679 C43.1420456,125.059309 40.7861897,127.264548 37.4069756,126.876656 C34.0277615,126.488764 32.2120113,123.884858 32.3221644,119.58572 C32.371911,117.689358 33.0932364,115.566726 29.7993022,115.423062 C24.1850453,115.186017 23.3713333,115.469753 22.9342741,119.043389 C22.8596542,119.65396 22.8454409,120.275306 22.7530544,120.885877 C22.1916287,124.689375 19.7007464,127.11011 16.5418385,126.944896 C13.0986645,126.765317 10.8565151,124.042888 11.0803747,119.944879 C11.2296144,117.35534 11.3966208,115.365597 7.72603387,115.405104 C2.66254267,115.458978 -0.0628592607,113.12085 0.00110062816,109.453833 C0.0579538627,105.86583 3.0853886,103.692916 7.96766011,103.714465 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#000000",
    strokeWidth: 1.06930693,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(84.782211, 78.943771) rotate(-12.240000) translate(-84.782211, -78.943771) ",
    cx: 84.7822111,
    cy: 78.9437715,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#000000",
    strokeWidth: 1.06930693,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(91.360647, 78.053819) rotate(-12.240000) translate(-91.360647, -78.053819) ",
    cx: 91.3606475,
    cy: 78.0538188,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4804619,81.3280586 C87.4804619,81.3280586 89.0616925,82.2546899 90.0281975,80.7605867",
    id: "\\u8DEF\\u5F84",
    stroke: "#000000",
    strokeWidth: 1.06930693,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#000000",
    strokeWidth: 1.06930693,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 28.6515775,
    cy: 92.1028411,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#000000",
    strokeWidth: 1.06930693,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 34.5181206,
    cy: 90.4866237,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4510761,95.5364051 C29.4510761,95.5364051 33.1181097,96.6821237 35.6480787,93.9201878 C38.1780476,91.1582518 40.246084,97.4794576 36.7140768,99.1351825 C33.1820696,100.790907 29.4510761,101.060277 28.1185784,98.3665813 C26.853594,95.8093663 29.4510761,95.5364051 29.4510761,95.5364051 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#000000",
    strokeWidth: 1.06930693,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3127143,46.277691 C55.8966381,46.2757126 54.7491694,45.1158864 54.7472121,43.68456 C54.7472121,43.3215644 55.0383429,43.0272983 55.397471,43.0272983 C55.7565991,43.0272983 56.0477299,43.3215644 56.0477299,43.68456 C56.0477299,44.3907154 56.6140827,44.9631675 57.3127143,44.9631675 C58.011346,44.9631675 58.5776988,44.3907154 58.5776988,43.68456 C58.6028515,43.341341 58.8856886,43.0758512 59.226181,43.0758512 C59.5666734,43.0758512 59.8495105,43.341341 59.8746632,43.68456 C59.8746632,45.1153053 58.7282142,46.2757093 57.3127143,46.277691 L57.3127143,46.277691 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#1A1F21",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2290041,46.277691 C61.8129278,46.2757126 60.6654591,45.1158864 60.6635018,43.68456 C60.6635018,43.3215644 60.9546327,43.0272983 61.3137607,43.0272983 C61.6728888,43.0272983 61.9640196,43.3215644 61.9640196,43.68456 C61.9640196,44.3907154 62.5303724,44.9631675 63.2290041,44.9631675 C63.9276357,44.9631675 64.4939885,44.3907154 64.4939885,43.68456 C64.5191412,43.341341 64.8019783,43.0758512 65.1424707,43.0758512 C65.4829631,43.0758512 65.7658002,43.341341 65.7909529,43.68456 C65.7909529,45.1153053 64.6445039,46.2757093 63.2290041,46.277691 L63.2290041,46.277691 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#1A1F21",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4766361,44.3633713 C52.7410165,44.3656592 52.9780118,44.528665 53.0771484,44.7764046 C54.3883261,48.0627133 57.2203278,50.188937 60.2904025,50.188937 C63.3604772,50.188937 66.0787724,48.1776443 67.4361434,44.9380264 C67.5269113,44.7218151 67.7249027,44.5709732 67.9555361,44.5423215 C68.1861696,44.5136697 68.4144063,44.6115609 68.5542718,44.7991204 C68.6941372,44.98668 68.7243826,45.235413 68.6336147,45.4516243 C67.0452774,49.1832907 63.847283,51.5178269 60.2939558,51.5178269 C56.7406287,51.5178269 53.3898412,49.0719513 51.8761238,45.286411 C51.7416809,44.9511911 51.9004828,44.5691723 52.2314565,44.4316116 C52.3081375,44.3932894 52.3913557,44.3701275 52.4766361,44.3633713 L52.4766361,44.3633713 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#1A1F21",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterSpace);
export default __webpack_public_path__ + "static/media/enter-space.d2892673d0c148fb4f0a1710d22073df.svg";
export { ForwardRef as ReactComponent };